//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Это компонент обертка над компонентом из UI-kit CommonSelect.
// Компонент импортируется из UI-kit под названием ECommonSelect.
// Подробнее о компоненте CommonSelect можно посмотреть в UI-kit и по необходимости добавить недостающий функционал из UI-kit.
// Был создан для того, чтобы добавить поддержку scaled layout и инкапсулировать логику автомасштабирования выпадающего меню.

import getScaleValue from '@/utils/getCurrentScaleValue';

export default {
  name: 'CommonSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [Array, Object, String],
      required: true,
    },
    optionLabel: {
      type: String,
      default: 'label',
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    label: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPlaceholderVisible() {
      return this.multiple && !this.value.length;
    },
  },
  mounted() {
    window.addEventListener('resize', this.autoscaleSelect);
    document.addEventListener('openSelect', this.autoscaleSelect);
  },
  destroyed() {
    window.removeEventListener('resize', this.autoscaleSelect);
    document.removeEventListener('openSelect', this.autoscaleSelect);
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    onOpen() {
      this.$nextTick(() => {
        document.dispatchEvent(new Event('openSelect'));
      });
    },
    autoscaleSelect() {
      setTimeout(() => {
        this.selectDropdownElements =
          document.querySelectorAll('.select__dropdown');
        this.selectDropdownElements.forEach((element) => {
          element.classList.add('autoscale');
        });
        this.menuElements = document.querySelectorAll('.menu');
        this.currentScale = getScaleValue('.autoscale');
        this.menuElements.forEach((element, index) => {
          element.style.height = `${
            this.selectDropdownElements[index].offsetHeight * this.currentScale
          }px`;
        });
      }, 0);
    },
  },
};
